export const STAT_USERS_REQUEST = "STAT_USERS_REQUEST";
export const STAT_USERS_SUCCESS = "STAT_USERS_SUCCESS";
export const STAT_USERS_FAIL = "STAT_USERS_FAIL";
export const STAT_LECTIONS_REQUEST = "STAT_LECTIONS_REQUEST";
export const STAT_LECTIONS_SUCCESS = "STAT_LECTIONS_SUCCESS";
export const STAT_LECTIONS_FAIL = "STAT_LECTIONS_FAIL";
